'use client';

import { useRef } from 'react';
import { useIntl } from 'react-intl';
import Heading from '@alltrails/denali/components/Heading';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import styles from './styles.module.scss';
import TrailVariantCard from './TrailVariantCard';

type TrailVariantsSectionProps = {
  trails?: TrailSearchResult[];
};

const TrailVariantsSection = ({ trails }: TrailVariantsSectionProps) => {
  const intl = useIntl();
  const containerRef = useRef<HTMLDivElement>(null);

  return trails && trails.length ? (
    <div className={styles.container} ref={containerRef}>
      <Heading as="h2" size="400" className={styles.heading}>
        {intl.formatMessage({ defaultMessage: 'Related trails' })}
      </Heading>
      {trails?.map(trail => (
        <TrailVariantCard key={trail.id} trail={trail} />
      ))}
    </div>
  ) : null;
};

export default TrailVariantsSection;
